export default {
    Today: "Today",
    Tomorrow: "Tomorrow",
    LiveRadioGuide: "Live Radio Guide",
    LiveTvGuide: "Schedule",
    LiveSportGuide:"Live Sports Guide",
    Channel: "CHANNELS",
    More: "More",
}